<!--
 * @Description: 教学单元 添加
 * @Author: PF
 * @Date: 2022-09-23 11:53:32
 * @LastEditors: PF
 * @LastEditTime: 2025-10-29 17:55:26
-->
<template>
  <div>
    <el-dialog class="w500 h400" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Edit /></el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="课程" prop="kcid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <!-- 单选 BEGIN -->
              <div class="an-niu wp100" style="display: flex; align-items: center;">
                <el-button type="primary" class="w100" @click="openKeChengDanTiao=true">选择</el-button>
                <el-button class="ml10 mr10" link v-if="ruleForm.kcmc" @click="ruleForm.kcmc='';ruleForm.kcid=''">清空</el-button>
                  <el-tag v-if="ruleForm.kcmc" :disable-transitions="false">
                    {{ ruleForm.kcmc }}
                  </el-tag>
              </div>
              <!-- 单选 END -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="教材" prop="jcid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jcid" filterable>
                <el-option v-for="(item, index) in jcData" :key="index" :label="item.jcmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="教学单元标题" prop="jxdybt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.jxdybt" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="顺序">
              <el-input-number v-model="ruleForm.sx" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <kechengdantiao v-if="openKeChengDanTiao" v-model:openDanTiao="openKeChengDanTiao" :row="row" @ReturnData="keChengReturnData"/>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { actionPost, submitForm, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import kechengdantiao from '@/components/chazhaodaihui/kechengdantiao.vue'

const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const shunXu = () => {
  actionPost({ url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/shunxu', data: { kcid: ruleForm.value.kcid, order: 'sx', sort: 'asc' } }).then((res) => {
    ruleForm.value.sx = res.data
  })
}

const jcData = ref()
const initJiaoCai = () => {
  actionPost({ url: '/api/v2/jiaowu/kecheng/jiaocai', data: { kcid: ruleForm.value.kcid } }).then((res) => {
    jcData.value = res.data
  })
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.kcid = props.row.kcid || ''
      ruleForm.value.kcmc = props.row.kcmc || ''
      ruleForm.value.jcid = props.row.jcid || ''
      ruleForm.value.jcmc = props.row.jcmc || ''
      shunXu()
      initJiaoCai()
    }
  },
  { deep: true, immediate: true }
)
const row = ref()
// 选择课程
const openKeChengDanTiao = ref(false)
const keChengReturnData = (data) => {
  ruleForm.value.kcid = data.id
  ruleForm.value.kcmc = data.kcmc
  shunXu()
  initJiaoCai()
}
// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
